import { Lightning, Router } from '@lightningjs/sdk'

import { getColor, grey50, grey920 } from '../../constants/colors'
import { UniNeueBold } from '../../constants/fonts'
import { getPaginateUrl } from '../../utils/floUtils'
import { captureClick, getCardPosition, SEGMENT_TRACK_EVENTS } from '../../utils/segmentAnalytics'
import TvBaseCard from './TvBaseCard'

export default class TvPaginationCard extends TvBaseCard {
  static _template() {
    return {
      ...super._template(),
      Container: {
        w: (w) => w,
        h: (h) => h,
        rect: true,
        color: getColor(grey920),
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: 16,
        },
        Label: {
          x: (w) => w / 2,
          y: (h) => h / 2,
          mount: 0.5,
          text: {
            text: '',
            textColor: getColor(grey50),
            fontSize: 40,
            fontFace: UniNeueBold,
          },
        },
      },
    }
  }

  get label() {
    return this.tag('Label')
  }

  get speechText(): string {
    return this.data?.title?.text
  }

  _init() {
    this.label.patch({
      text: {
        text: this.data?.title?.text ?? '',
      },
    })
  }

  _handleEnter() {
    void captureClick(
      SEGMENT_TRACK_EVENTS.ButtonClicked,
      this.data?.action?.analytics,
      getCardPosition(this),
    )

    Router.navigate(getPaginateUrl(this.data?.action?.url))
  }

  _handleClick() {
    this._handleEnter()
  }
}
